import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "../components/CustomDate.css";

import { useEffect } from 'react';



const CustomInput = React.forwardRef(({ onClick, value, onChange, readOnly, ...rest }, ref) => {


    const handleChange = (e) => {
        let { value } = e.target;

        // Remove all non-numeric characters
        value = value.replace(/[^0-9]/g, '');

        // Insert hyphens at the appropriate positions
        if (value.length >= 3) {
            value = `${value.slice(0, 2)}-${value.slice(2)}`;
        }
        if (value.length >= 6) {
            value = `${value.slice(0, 5)}-${value.slice(5)}`;
        }

        // Limit length to 10 characters
        if (value.length > 10) {
            value = value.slice(0, 10);
        }
        onChange({ target: { value } });
    };

    const handleKeyDown = (e) => {
        console.log({ e });
        if (e.key === 'Backspace') {
            let { value } = e.target;

            // Remove hyphens before handling backspace
            value = value.replace(/[^0-9]/g, '');

            // Delete the last character
            value = value.slice(0, -1);

            // Reinsert hyphens
            if (value.length >= 3) {
                value = `${value.slice(0, 2)}-${value.slice(2)}`;
            }
            if (value.length >= 6) {
                value = `${value.slice(0, 5)}-${value.slice(5)}`;
            }

            onChange({ target: { value } });
            e.preventDefault();
        }
    };
    return (
        <input
            onClick={onClick}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            {...rest}
            type="text"
            ref={ref}
        />
    );
});


const CustomDatePicker = (props) => {
    const [startDate, setStartDate] = useState('');
    const [MaxDate, setMaxDate] = useState('');
    const [MinDate, setMinDate] = useState('');

    

   
    useEffect(() => {
        if (props.maxDate !== undefined) {
            setMaxDate(props.maxDate)
        }
        if (props.minDate !== undefined) {
            setMinDate(props.minDate)
        }
    },[props.maxDate, props.minDate])

    useEffect(() => {
        if (props.RegDate !== "" && props.RegDate !== null && props?.RegDate !== undefined) {
            setStartDate(props.RegDate);
        }
    }, [props.RegDate])

    const handleKeyDown = (e) => {
        // Allow only numeric characters (0-9) and backspace
        if (!/^[0-9 -]$/.test(e.key) && e.key !== 'Backspace') {
            e.preventDefault();
        }
    };

    return (
        <div className="mui-datepicker">
            <i class="datepicker-icon far fa-calendar-alt"></i>
            <DatePicker
                selected={startDate}
                onChange={(date) => { props.setDOB(date); setStartDate(date) }}
                minDate={MinDate}
                maxDate={MaxDate}
                placeholderText="dd-MM-yyyy"
                dateFormat="dd-MM-yyyy"
                peekNextMonth
                peekNextYear
                showMonthDropdown
                showYearDropdown
                yearDropdownItemNumber={90}
                scrollableYearDropdown={true}
                customInput={< CustomInput />}
            />
        </div>
    );
};

export default CustomDatePicker;
